import React, {  useState } from "react";
import DataTable from "../../Components/DataTable";
import Input, { Label } from "../../Components/Input";
import useFetchData from "../../Hooks/useFetchData";
import useInput from "../../Hooks/useInput";
import Modal from "react-awesome-modal";
import useSave from "../../Hooks/useSave";
import useDeleteData from "../../Hooks/useDeleteData";


const ApproverModule = () => {
    const [Editing, setEditing] = useState(false);
    const initialState = {
        module: "",
        minApprovers: 2
    };
    const url = "api/ApproverModules/";
    const { response, error, isLoading } = useFetchData(url);

    const { HandleDelete, HandleEditData } = useDeleteData(url);
    const { values, HandleChange, reset, FillData } = useInput(initialState);
    const [openModel, setOpenModel] = useState(false);

    let TableHeader = ["Module", "Min Approvers"];
    let rowData = ["module", "minApprovers"];

    const handleEdit = k => {
        const data = {
            id: k.id,
            module: k.module,
            minApprovers: k.minApprovers
        };
        FillData(data);
        setEditing(true);
    };
    const handleDelete = k => {
        HandleDelete(k.id);
        response.splice(response.indexOf(k), 1);
    };
    const HandleSubmit = e => {
        e.preventDefault();
        handleModel(false)
        useSave(url, values);
        reset();
        response.push(values)
    };
    const HandleUpdate = e => {
        e.preventDefault();
        handleModel(false)
        HandleEditData(values);
        reset();
        response.splice(response.indexOf(values), 1, values);
    };
    const HandleOnClose = e => {
        e.preventDefault();
        setEditing(false);
        handleModel(false);
        reset();
    };
    const handleModel = (e) => {
        setOpenModel(e);
    }
    const handleResetModel = () => {
        setEditing(false);
        reset();
    }
    return (
        <div>
            {isLoading ? (
                <p>Loading</p>
            ) : (
                    <DataTable
                        page={"Approver Modules"}
                        data={response}
                        HandleOnClose={HandleOnClose}
                        handleEdit={e => handleEdit(e)}
                        handleDelete={e => handleDelete(e)}
                        rowData={rowData}
                        TableHeader={TableHeader}
                        handleModel={(e) => handleModel(e)}
                        handleResetModel={handleResetModel}
                    >
                        <ApproverModuleForm
                            values={values}
                            IsEditing={Editing}
                            HandleUpdate={HandleUpdate}
                            HandleOnClose={HandleOnClose}
                            HandleSubmit={HandleSubmit}
                            HandleChange={HandleChange}
                            openModel={openModel}
                            handleModel={(e) => handleModel(e)}
                        />
                    </DataTable>
                )}
        </div>
    );
};

export default ApproverModule;

const ApproverModuleForm = props => {
    return (
        <Modal visible={props.openModel} width="45%" cccceffect="fadeInUp">
            <div style={{ "overflow-y": "scroll", height: "100%" }}>
                <div className="modal-header">
                    <h4 className="modal-title">Add Approver Module</h4>
                    <button
                        onClick={() => props.handleModel(false)}
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-hidden="true"
                    >
                        ×
                    </button>
                </div>
                <div className="modal-body">
                    <div className="row">
                        <div className="col-md-10 md-offset-2">
                            <div className="form-group row m-b-10">
                                <Label label="Module" isRequired={true} />
                                <div className="col-md-8">
                                    <Input
                                        name="module"
                                        value={props.values.module}
                                        HandleChange={props.HandleChange}
                                    />
                                </div>
                            </div>
                            <div className="form-group row m-b-10">
                                <Label label="Min Approvers" isRequired={true} />
                                <div className="col-md-8">
                                    <Input
                                        name="minApprovers"
                                        value={props.values.minApprovers}
                                        HandleChange={props.HandleChange}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <a
                        className="btn btn-white"
                        data-dismiss="modal"
                        onClick={props.HandleOnClose}
                    >
                        Close
        </a>
                    {props.IsEditing ? (
                        <button
                            type="submit"
                            onClick={props.HandleUpdate}
                            className="btn btn-primary"
                        >
                            Update
                        </button>
                    ) : (
                            <button
                                type="submit"
                                onClick={props.HandleSubmit}
                                className="btn btn-primary"
                            >
                                Save
                            </button>
                        )}
                </div>
            </div>
        </Modal>

    );
};
